import styled from 'styled-components'
import tw from 'twin.macro'

export const BaseTag = styled.div`
  ${tw`font-inter text-xs leading-4 font-medium py-[2px] px-2 rounded-[6px] w-fit`}
`
export const InProcessTag = styled(BaseTag)`
  ${tw`bg-pattensBlue text-blueGray800`}
`

export const PendingTag = styled(BaseTag)`
  ${tw`bg-yellow100 text-yellow800`}
`
export const VerifiedTag = styled(BaseTag)`
  ${tw`bg-emerald100 text-emerald800 flex items-center justify-center`}
`
export const VerifiedIconWrapper = styled.div`
  ${tw`mr-1`}
`

export const FailedTag = styled(BaseTag)`
  ${tw`bg-red100 text-red800`}
`
